import { render, staticRenderFns } from "./reasonComponent.vue?vue&type=template&id=fe400594&"
import script from "./reasonComponent.vue?vue&type=script&lang=js&"
export * from "./reasonComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports